// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.jobview[data-v-6b6574f1] {
  transition: 0.3s all linear;
  position: fixed;
  left: 0;
  right: 0;
  top: 80px;
  bottom: -30px;
  z-index: 200;
}
/* .jobview-show{ right: 15px; left:20px !important; } */
.jobview-show[data-v-6b6574f1] {
  top: 65px;
  left: 0;
}
.jobview-hide[data-v-6b6574f1] {
  position: absolute;
  left: 0;
  top: 0px;
  bottom: 0px;
}
.jobview-hide .v-btn[data-v-6b6574f1] {
  position: absolute;
  left: -94px;
  top: 160px;
  z-index: 10;
  transform: rotate(90deg);
  padding-top: 0px !important;
  outline: solid 5px rgba(252, 81, 133, 0.5);
  margin-right: 6px;
  animation-timing-function: linear;
  animation: mymove-6b6574f1 1.5s infinite;
  animation-fill-mode: both;
}
.jobview-hide[data-v-6b6574f1] .v-btn__content {
  padding-left: 5px;
}
.dashboard .jobview.jobview-show[data-v-6b6574f1] .claim-btn-content,
.dashboard .jobview.jobview-show[data-v-6b6574f1] .claim-btn-content .v-card,
.dashboard .jobview.jobview-show[data-v-6b6574f1] .mapsidebar-content.v-card,
.show-jobs .jobview[data-v-6b6574f1] {
  z-index: 202 !important;
}
@media only screen and (max-width: 1300px) {
.dashboard .jobview.jobview-show[data-v-6b6574f1] .claim-btn-content {
    right: 25.3%;
    left: 38%;
}
}

/* Standard syntax */
@keyframes mymove-6b6574f1 {
0% {
    outline-width: 1px;
}
50% {
    outline-width: 5px;
}
100% {
    outline-width: 1px;
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
